import { useLocation } from "react-router-dom";
import "../styles/rules.scss";
import { useEffect, useState } from "react";
import { getRuleById } from "../components/api";
import { setNotificationMessage, setShowNotification } from "../store";
import { IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

export const Rule = () => {

    const [rule, setRule] = useState(null);

    const location = useLocation();
    const { ruleId } = location.state || {};

    useEffect(() => {
        getRuleById(ruleId)
            .then((data) => { setRule(data) })
            .catch(error => {
                setNotificationMessage("Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    }, []);

    const backClick = () =>{
        window.location.href = "/rules";
    }

    return (
        <div className="rule">
            <IconButton className="rule__back" onClick={() => backClick()}><ArrowBack className="rule__back__icon" /></IconButton>
            <h2>{rule?.title}</h2>
            <div className="rule__text" dangerouslySetInnerHTML={{ __html: rule?.text }} style={{ wordBreak: "break-word" }} />
        </div>
    )
}
        